import type { BespokeTemplateResponse } from '../../services/api/types.gen';
import {
  bespokeTemplateMatchesPin,
  type FormSchemaVersionPin,
} from './formSchemaUtils';

export function bespokeStatusTier(status: BespokeTemplateResponse['status']) {
  if (status === 'live') return 0;
  if (status === 'paused') return 1;
  return 2;
}

export function countBespokeBulkTargets(
  templatesList: BespokeTemplateResponse[],
  direction: 'pause' | 'resume',
  pinsFilter: FormSchemaVersionPin[] | null
): number {
  let wants =
    direction === 'pause'
      ? templatesList.filter(t => t.status === 'live')
      : templatesList.filter(t => t.status === 'paused');
  if (pinsFilter != null) {
    wants = wants.filter(t =>
      pinsFilter.some(pin => bespokeTemplateMatchesPin(t, pin))
    );
  }
  return wants.length;
}
